import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ReactTooltip from 'react-tooltip';

import _ from 'lodash';

import helpers from 'helpers';
import { letterMapper, AnnotationTooltip } from 'helpers/annotations';

import SelectedTextPopup from './SelectedTextPopup';

class AnnotationEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            renderContent: [],
            openPopover: false,
        };

        this.onMouseUp = this.onMouseUp.bind(this);
        this.closePopover = this.closePopover.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        let { letterText, annotations } = newProps;


        if (letterText && annotations.length > 0) {
            const clearedAnnotations = this.clearUnusefullWords(annotations);
            const sortedAnnotations = this.sortForLongerAnnotate(clearedAnnotations);
    
            this.createRenderedContent(
                letterText,
                sortedAnnotations,
            );
        }
        else {
            this.setState({
                renderContent: undefined,
                tooltips: undefined
            });
        }
    }

    sortForLongerAnnotate(annotations) {
        return _.sortBy(annotations, (a, b) => {
            return -a.features.string.length;
        });
    }

    clearUnusefullWords(annotations) {
        const array = annotations.filter((annotation) => {
            return (
                annotation.type !== 'Lookup' && 
                annotation.type !== 'Sentence' && 
                annotation.type !== 'Split' && 
                _.has(annotation, 'features.rule') &&
                annotation.features.rule.toLowerCase().includes('saf') && 
                annotation.type.toLowerCase().includes('cargoannotation')
            );
        });

        const map = new Map();
        for (const item of array) {
            const key = item.type + "-" + item.features.rule + "-" + item.start + "-" + item.end;
            map.set(key, item);
        }

        return Array.from(map.values());
    }

    createRenderedContent(letterText, annotations) {
        let renderContent = letterText.split('');

        renderContent = renderContent.map((symbol, symbolPosition) => {
            symbol = symbol === ' ' ? '\u00A0' : symbol;
            return {
                symbol,
                symbolPosition,
                style: {},
                ids: [],
                tooltipContent: [],
            };
        });

        for (let i = 0; i < annotations.length; i++) {
            const hashColor = helpers.createHashColor();
            for (let j = annotations[i].start; j < annotations[i].end; j++) {
                if(renderContent[j]) {
                    renderContent[j].style = {
                        background: hashColor,
                    };
                    renderContent[j].ids.push(annotations[i].id);
                    renderContent[j].tooltipContent.push({
                        rule: annotations[i].features.rule,
                        type: annotations[i].type,
                    });
                } else {
                    console.warn(`Wrong list of annotations. Please reannotate letter.`);
                }
            }
        }

        const tooltips = this.createTooltips(renderContent);
        
        this.setState({
            renderContent,
            tooltips
        });
    }

    createTooltips(characters) {
        const map = new Map();
        for (const char of characters) {
            map.set(char.ids.join(''), char);
        }
        return Array.from(map.values());
    }

    onMouseUp(ev) {
        const range = helpers.getSelection(ev.target.parentNode);

        if (range.start === range.end) {
            return;
        }

        const hashColor = helpers.createHashColor();
        const renderContent = this.state.renderContent.slice(0);

        renderContent.forEach((el) => {
            if (el.position >= range.start && el.position < range.end) {
                renderContent.push({
                    style: {
                        background: hashColor,
                    },
                });
            }
        });

        this.setState({
            renderContent,
            openPopover: true,
            anchorEl: ev.target,
            chosenText: range.string,
        });
    }

    closePopover() {
        this.setState({
            openPopover: false,
        });
    }

    render() {
        const { openPopover, anchorEl, chosenText } = this.state;
        const { annotations, letterText } = this.props;

        return (
            <div>
                <SelectedTextPopup
                    openPopover={openPopover}
                    anchorEl={anchorEl}
                    closePopover={this.closePopover}
                    chosenText={chosenText}
                />
                <div className='letter-text' onMouseUp={this.onMouseUp}>
                    {
                        this.state.renderContent
                            ? Array.from(letterMapper(this.state.renderContent))
                            : letterText
                    }
                </div>
                <AnnotationTooltip tooltips={this.state.tooltips} renderTooltip={tooltip => (
                    <div className='tooltip-row'>
                        {
                            tooltip.tooltipContent.map((t, k) => {
                                return (<div key={k} className='tooltip-column'>
                                    <div className='col'>{`Rule - ${t.rule}, `}</div>
                                    <div className='col'>{`Type - ${t.type}`}</div>
                                </div>);
                            })
                        }
                    </div>
                )} />
            </div>
        );
    }
}

export default connect(
    ({ annotations: { items: annotations }}, { letterText }) => {
        return {
            letterText,
            annotations,
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(AnnotationEditor);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Content/AnnotationsEditor.jsx